import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ResourceService } from '@teem/generic/resource.service';
import { invoice as InvoiceApi } from '@teem/constants/api';
import { Invoice, InvoiceSerializer } from '@teem/models/invoice';

@Injectable({
  providedIn: 'root'
})
export class InvoiceService extends ResourceService<Invoice> {

  constructor(httpClient: HttpClient) {
    super(
      httpClient,
      InvoiceApi.endPoint,
      new InvoiceSerializer()
    )
  }

  public action(params: any) {
    return this.httpClient.patch(`${InvoiceApi.action}`, params);
  }

  public list(): Observable<Invoice[]> {
    return this.httpClient.get(`${InvoiceApi.list}`, this.httpOptions)
      .pipe(map((r: any) => this.convertData(r)));
  }

  public stats() {
    return this.httpClient.get(`${InvoiceApi.stats}`, this.httpOptions);
  }

  public commonData() {
    return this.httpClient.get(`${InvoiceApi.common}`, this.httpOptions);
  }

  public createPayment(data: any) {
    return this.httpClient.post(`${InvoiceApi.received_payments}`, data, this.httpOptions);
  }

  public refundPayment(data: any) {
    return this.httpClient.post(`${InvoiceApi.refund_payment}`, data, this.httpOptions);
  }

  public deletePayment(uuid: string) {
    return this.httpClient.delete(`${InvoiceApi.deletePayment(uuid)}`);
  }

  public resendPayment(uuid: string) {
    return this.httpClient.get(`${InvoiceApi.resendPayment(uuid)}`);
  }

  public acceptPayment(uuid: string) {
    return this.httpClient.get(`${InvoiceApi.acceptPayment(uuid)}`);
  }

  public refundOnlinePayment(uuid: string) {
    return this.httpClient.get(`${InvoiceApi.refundOnlinePayment(uuid)}`);
  }

  public rejectPayment(uuid: string) {
    return this.httpClient.get(`${InvoiceApi.rejectPayment(uuid)}`);
  }

  public quickPaymentLink(data: any) {
    return this.httpClient.post(`${InvoiceApi.quick_payments}`, data, this.httpOptions);
  }

  public getProductAndServices() {
    return this.httpClient.get(`${InvoiceApi.products_services_list}`);
  }

  public getInvoiceQrCode(data: any) {
    return this.httpClient.post(`${InvoiceApi.qr_code_base64}`, data, this.httpOptions);
  }

  public reCallInvoiceInfo(uuid: string) {
    return this.httpClient.get(`${InvoiceApi.reCallInvoiceInfo(uuid)}`);
  }

}
